import { setTheme } from "theme/default/setTheme";

export const setColor_69809a = setTheme(({ theme }) => `color: ${theme.colors.color_69809a}`);
